import z from 'zod';
import { defineObject } from 'sanity-typed-queries';
import department from './department.js';
import arrayEntry from '../fragments/arrayEntry.js';
var schema = defineObject('departmentsSection', {
    title: {
        title: 'Title',
        type: 'string'
    },
    subtitle: {
        title: 'Subtitle',
        type: 'string'
    },
    departments: {
        title: 'Departments',
        type: 'array',
        of: [
            {
                type: 'department'
            }
        ]
    }
}, [
    department.schema.department
]);
var validator = z.object({
    _type: z.literal('departmentsSection'),
    title: z.string().optional().nullable(),
    subtitle: z.string().optional().nullable(),
    departments: z.array(department.validator.merge(arrayEntry.validator)).optional().nullable()
});
schema.departmentsSection;
export default {
    schema: schema,
    validator: validator
};

//# sourceMappingURL=departmentsSection.js.map